import Cookies from 'js-cookie';
import actions from './actions';
import ls from 'local-storage';

const { INITIAL_STEP,NEXT_STEP, SIGNIN_BEGIN, SIGNIN_SUCCESS, SIGNIN_ERR, SIGNOUT_BEGIN, SIGNOUT_SUCCESS, 
  SIGNUP_ERR, FORGOT_BEGIN, FORGOT_ERR, FORGOT_SUCCESS, IS_LOADING, SET_DATAFORM, UNLOADING, RESET_DATA, RESET_DIALOG , SET_DIALOG, SET_TITLE,SUCCESS_DIALOG, SET_INLINE,PREVIOUS,KYC_POST_FAIL,KYC_PRE_FAIL,SET_KYC_STEP,SET_PW_STEP,SET_KYC_DIALOG,CDD_FAIL_STATUS,SIGNING_REF_VALIDATION_FAILED,SET_SIGNIN_OTP_STEP,MANUAL_REJECT_STATUS,SET_NAME_NRIC_UPDATE_STEP} = actions;


const initState = {
  login: ls.get('login-session') || null,
  loading: false,
  error: null,
  step: 0,
  stepname: '',
  dialog: {},
  inline:{},
  dataForm: {
    name: "",
    phoneNumber: "",
    email: "",
    confirmEmail: "",
    termsAcknowledgement: false,
    bankID: "",
    bankAccountNumber: "",
    bankTermsAcknowledgement: false,
    customerId:"",
    kycToken:"",
    password:""
  },
  isKongsiDialogShow: false,
  isDialogShow: false
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err, name } = action;
  switch (type) {
    case IS_LOADING:
      console.log(state)
      return {
        ...state,
        loading: true,
      };
    case NEXT_STEP:
      console.log(state)
      return {
        ...state,
        step : state.step + 1,
        stepname:data || ''
      };
    case KYC_PRE_FAIL:
      console.log(state)
      return {
        ...state,
        step : 100,
        stepname:data || ''
      };
    case INITIAL_STEP:
      console.log(state)
      return {
          ...state,
          step : 1,
          stepname:data || ''
      };
    case CDD_FAIL_STATUS:
      console.log(state)
      return {
        ...state,
        step: 200,
        stepname: data || ''
      };
    case MANUAL_REJECT_STATUS:
        console.log(state)
        return {
          ...state,
          step: 300,
          stepname: data || ''
        };
    case KYC_POST_FAIL:
        console.log(state)
        return {
          ...state,
          step : -1,
          stepname:data || ''
        };
    case SET_KYC_STEP:
        console.log(state)
        return {
          ...state,
          step : 3,
          stepname:data || ''
        };
    case SET_PW_STEP:
      console.log(state)
      return {
        ...state,
        step: 4,
        stepname: data || ''
      };
    case SET_NAME_NRIC_UPDATE_STEP:
      console.log(state)
      return {
        ...state,
        step: 300,
        stepname: data || ''
      };
    case SET_SIGNIN_OTP_STEP:
      console.log(state)
      return {
        ...state,
        step: 3,
        stepname: data || ''
      };
    case SET_DATAFORM:
      let init = state.dataForm
      init = {...init, ...data}
      console.log(init)
      return {
        ...state,
        dataForm:init,
        loading:false
      };

    case SET_DIALOG:
      console.log(data)
      return {
        ...state,
        dialog:data
      };
    case SET_TITLE:
      console.log(data)
      return {
          ...state,
          title:data
      };
    case SET_KYC_DIALOG:
      console.log(data)
      return {
        ...state,
        kycDialog: data
      };

    case SUCCESS_DIALOG:
        console.log(data)
        return {
          ...state,
          dialog:data
        };
  
    case RESET_DIALOG:
      console.log(data)
      return {
        ...state,
        dialog:null
      };
    
    case SIGNIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SIGNIN_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case SIGNIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case SIGNOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SIGNOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case UNLOADING:
      return {
        ...state,
        loading: false,
      };
    case SIGNUP_ERR:
      return {
        ...state,
        error: err,
        step : 'ERROR',
        loading: false,
      };
    case FORGOT_BEGIN:
        return {
          ...state,
          loading: true,
        };
    case FORGOT_SUCCESS:
        return {
          ...state,
          login: data,
          loading: false,
        };
    case FORGOT_ERR:
        return {
          ...state,
          error: err,
          loading: false,
        };
    case RESET_DATA: {
      return { ...initState };
    }
    case SET_INLINE:{
      console.log(data)
      return {
        ...state,
        inline:data
      }
    }
    case PREVIOUS:{
      return {
        ...state,
        step : state.step - 1,
        stepname:data || ''
      };
    }
    case SIGNING_REF_VALIDATION_FAILED: {
      return {
        ...state,
        signinTokenValidationFailed: true,
      };
    }
    default:
      return state;
    }
};
export default AuthReducer;
